import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'any' })
export class ObjectDataState<T> {
  private data?: T;

  setData(data: T): void {
    this.data = data;
  }

  getData(): T | undefined {
    return this.data;
  }

  clearData(): void {
    this.data = undefined;
  }
}
